<template>
  <!-- Quotation定制化服务-小计 -->
  <div class="packageWrap">
    <div class="packageLeft">
      <p class="fs14 fwb mb6" v-if="businessType == 'COMPREHENSIVE_CUSTOMIZED'">Comprehensive Corporate Services (customized)</p>
      <p class="fs14 fwb mb6" v-if="businessType == 'FUND_ADMIN_CUSTOMIZED'">Fund Admin Services (customized)</p>
      <p>
        <span class="fs20 fwb orange vam">{{ currencyAndAmountFormat(billingCurrency, quotationPart.subTotalPrice) }}</span>
        <span class="ml6 fs14 fwb blackD8 vam">({{ quotationPart.subTotalDesp }})</span>
      </p>
    </div>
    <div class="packageRight">
      <div class="flex flex-direction-row details">
        <div class="mr20">
          <!-- 套餐包含： -->
          <p class="fs12 fwb">Package Includes:</p>
          <ul class="fs12 black45 lh22">
            <li v-for="son in quotationPart.itemList" :key="`son-${son.id}`">
              <span class="fwb green fs12 el-icon-check"></span>
              {{ son.title }}
              <span>({{ currencyAndAmountFormat(billingCurrency, serviceChargeCalculation(son.amount, son.thirdPartyFee, son.otherFee)) }})</span>
              <el-popover placement="bottom" trigger="hover" v-if="son.startDate && son.endDate">
                <span class="fs12">{{ son.startDate }} ~ {{ son.endDate }}</span>
                <span slot="reference" class="ml2 fs13 blackD8 el-icon-question"></span>
              </el-popover>
            </li>
          </ul>
        </div>
        <!-- 第三方费用 -->
        <div class="mr20">
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            Third Party Fee:
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="part in mergeSameAttrList(quotationPart.itemList, 'noteForThirdParty', 'thirdPartyFee')" :key="`part-${part.id}`">
              <span v-if="part.noteForThirdParty">- {{ part.noteForThirdParty }}</span>
              <span v-if="$isNumberLike(part.thirdPartyFee)">({{ currencyAndAmountFormat(billingCurrency, part.thirdPartyFee) }})</span>
            </li>
          </ul>
        </div>
        <!-- 其他费用 -->
        <div>
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            Other Fee:
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="other in mergeSameAttrList(quotationPart.itemList, 'noteForOther', 'otherFee')" :key="`other-${other.id}`">
              <span v-if="other.noteForOther">- {{ other.noteForOther }}</span>
              <span v-if="$isNumberLike(other.otherFee)">({{ currencyAndAmountFormat(billingCurrency, other.otherFee) }})</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
import priceCountMixin from "@/mixins/priceCountMixin";
export default {
  mixins: [formatterMixin, priceCountMixin],
  props: {
    businessType: {
      type: String,
      default: () => "",
    },
    quotationPart: {
      type: Object,
      default: () => {},
    },
    billingCurrency: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.packageWrap {
  display: flex;
  width: 100%;
  padding: 16px;
  background-color: #fdf6ec;

  .packageLeft {
    padding-right: 16px;
    max-width: 250px;
  }

  .packageRight {
    padding-left: 16px;
    border-left: 1px solid #e4e7ed;
  }

  p {
    line-height: 20px;
    margin: 0;
    color: #011a45;
  }
}
</style>
